import { Badge } from "@/components/ui/badge";

const creatorStatusMap = {
  Prospect: "bg-slate-100 text-slate-700 border-slate-200",
  Locked: "bg-emerald-50 text-emerald-700 border-emerald-200",
  Cancelled: "bg-rose-50 text-rose-700 border-rose-200",
};

const scriptMap = {
  "Script Pending": "bg-slate-100 text-slate-700 border-slate-200",
  "Script Shared with Brand": "bg-sky-50 text-sky-700 border-sky-200",
  "Rework on Script": "bg-amber-50 text-amber-700 border-amber-200",
  "Script Approved": "bg-indigo-50 text-indigo-700 border-indigo-200",
  "Shoot Done": "bg-violet-50 text-violet-700 border-violet-200",
  "Video Shared": "bg-purple-50 text-purple-700 border-purple-200",
  "Video Rework": "bg-amber-50 text-amber-700 border-amber-200",
  "Video Approved": "bg-teal-50 text-teal-700 border-teal-200",
  "Live": "bg-blue-50 text-blue-700 border-blue-200",
};

const paymentMap = {
  Unpaid: "bg-rose-50 text-rose-700 border-rose-200",
  Partial: "bg-amber-50 text-amber-700 border-amber-200",
  Paid: "bg-emerald-50 text-emerald-700 border-emerald-200",
};

const badgeCls = "font-medium rounded-full px-2.5 py-0.5 text-[11px]";

export function CreatorStatusBadge({ value }) {
  return <Badge variant="outline" className={`${creatorStatusMap[value] || creatorStatusMap.Prospect} ${badgeCls}`}>{value || "Prospect"}</Badge>;
}
export function ScriptStatusBadge({ value }) {
  return <Badge variant="outline" className={`${scriptMap[value] || scriptMap["Script Pending"]} ${badgeCls}`}>{value || "Script Pending"}</Badge>;
}
export function PaymentStatusBadge({ value }) {
  return <Badge variant="outline" className={`${paymentMap[value] || paymentMap.Unpaid} ${badgeCls}`}>{value || "Unpaid"}</Badge>;
}
